<h1 mat-dialog-title>Create videos file specification</h1>
<mat-dialog-content class="dialog-body">
  <section class="field-group">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Name</mat-label>
      <input matInput [formControl]="nameControl" type="text" />
    </mat-form-field>
  </section>

  <section class="field-group">
    <h3 class="group-title">Format</h3>
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Format</mat-label>
      <mat-select [formControl]="formatControl">
        @for (f of videoFormats; track f) {
          <mat-option [value]="f">{{ formatLabel(f) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </section>

  <section class="field-group">
    <h3 class="group-title">Dimensions</h3>
    <div class="pair-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Width (px)</mat-label>
        <input matInput [formControl]="widthControl" type="number" min="1" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Height (px)</mat-label>
        <input matInput [formControl]="heightControl" type="number" min="1" />
      </mat-form-field>
    </div>
  </section>

  <section class="field-group">
    <h3 class="group-title">Bit rate</h3>
    <div class="toggle-row">
      <span class="toggle-label">Mode</span>
      <mat-button-toggle-group [formControl]="bitRateModeControl">
        @for (m of bitRateModes; track m) {
          <mat-button-toggle [value]="m">{{ bitRateModeLabel(m) }}</mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    @if (isFixedBitRate) {
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Mbps</mat-label>
        <input matInput [formControl]="mbpsControl" type="number" min="1" />
      </mat-form-field>
    }
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    [disabled]="!canSubmit"
    (click)="submit()"
  >
    Create
  </button>
</mat-dialog-actions>
